import { useDebounced, useApiQuery, queryString } from './hooks';
import type { OrgApi } from './useOrgApi';
import type { Paged, QrFilters, QrSummary } from './types';

/** `GET /v1/qrs` con filtros; la búsqueda libre espera 300 ms sin teclear. */
export function useQrList(client: OrgApi, filters: QrFilters) {
  const q = useDebounced(filters.q ?? '', 300);
  return useApiQuery<Paged<QrSummary>>(
    (signal) =>
      client.get<Paged<QrSummary> | QrSummary[]>(
        `/v1/qrs${queryString({ state: filters.state, kind: filters.kind, lotId: filters.lotId, custodianUid: filters.custodianUid, q: q.trim() })}`,
        { signal },
      ).then((res) => (Array.isArray(res) ? { items: res } : { items: res.items ?? [], nextCursor: res.nextCursor })),
    [client, filters.state, filters.kind, filters.lotId, filters.custodianUid, q],
  );
}
